import { render, staticRenderFns } from "./ActivateTruck.vue?vue&type=template&id=f6ca46ca&scoped=true"
import script from "./ActivateTruck.vue?vue&type=script&lang=js"
export * from "./ActivateTruck.vue?vue&type=script&lang=js"
import style0 from "./ActivateTruck.vue?vue&type=style&index=0&id=f6ca46ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6ca46ca",
  null
  
)

export default component.exports